const MILLISECOND_IN_A_DAY = 86_400_000;

/**
 * Returns the number of days left in the trial
 * @param timeLeft The number of milliseconds until the end of the trial
 */
export function getTrialDaysLeft(timeLeft?: number | null) {
	if (timeLeft === null || timeLeft === undefined) {
		return undefined;
	}

	if (timeLeft <= 0) {
		return 0;
	}

	// Use Math.ceil to round up for fractional days
	return Math.ceil(timeLeft / MILLISECOND_IN_A_DAY);
}

/**
 * Returns the number of days left in the trial
 * @param trialEndTime The timestamp in milliseconds of the end of the trial
 * @deprecated use {@link getTrialDaysLeft} using timeLeft instead
 */
export function getTrialDaysLeftFromTrialEndTime(trialEndTime?: number | null) {
	if (trialEndTime === null || trialEndTime === undefined) {
		return undefined;
	}

	return getTrialDaysLeft(trialEndTime - Date.now());
}
